import React, { Fragment } from "react";
import LayoutOne from "../layouts/LayoutOne";
import Gallery from "../components/Gallery/Gallery";
import PageHeader from '../components/PageHeader';
import Seo from '../components/Seo';

const galleryPage = () => {
	return (
	  <Fragment>
		<Seo
		  title="Customer Testimonials & Reviews | Navy Seals Moving"
		  description="Watch real customers review their moves with Navy Seals Moving, long-distance and local moves rated 5 stars across Google, Yelp, and more."
		/>
		<LayoutOne>
			<PageHeader
				bgImg={(process.env.PUBLIC_URL + '/assets/images/page_bg.jpg')}
				title="Testimonials"
			/>

			<Gallery classes="work_page" />

		</LayoutOne>
	  </Fragment>
	);
  };
  
  export default galleryPage;



